import React from "react";

export function Logo({ className = "h-8", variant = "dark" }) {
  const textColor = variant === "light" ? "#FFFFFF" : "#0F172A";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="expoflo-logo">
      <svg viewBox="0 0 40 40" className="h-full aspect-square" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="expoLogoGrad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop stopColor="#E91E93" />
            <stop offset="1" stopColor="#7C3AED" />
          </linearGradient>
        </defs>
        <path
          d="M20 3C10.6 3 3 10.6 3 20c0 5.5 2.6 10.4 6.6 13.5V37l5-3.1c1.7.4 3.5.6 5.4.6 9.4 0 17-7.6 17-17S29.4 3 20 3Z"
          stroke="url(#expoLogoGrad)"
          strokeWidth="2.5"
          fill="none"
        />
        {/* waveform */}
        <g fill="url(#expoLogoGrad)">
          <rect x="12" y="16" width="2.4" height="8" rx="1.2" />
          <rect x="16" y="12" width="2.4" height="16" rx="1.2" />
          <rect x="20" y="14" width="2.4" height="12" rx="1.2" />
          <rect x="24" y="17" width="2.4" height="6" rx="1.2" />
        </g>
      </svg>
      <div className="flex flex-col leading-none">
        <span
          className="font-display font-bold text-[1.05em] tracking-tight"
          style={{ color: textColor }}
        >
          ExpoFlo<span className="brand-gradient-text">.AI</span>
        </span>
      </div>
    </div>
  );
}

export default Logo;
